export const Trust = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 20">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
      d="M27 17.901v-1.43c0-1-.354-1.959-.982-2.666-.628-.707-1.597-1.104-2.485-1.104h-1.734M21.803 10.1a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2ZM19.854 19.2v-4.03a3.77 3.77 0 0 0-3.77-3.77H11.27a3.77 3.77 0 0 0-3.77 3.77v4.03M13.871 8.539a3.77 3.77 0 1 0 0-7.54 3.77 3.77 0 0 0 0 7.54ZM1 17.901v-1.43c0-1 .353-1.959.982-2.666.628-.707 1.596-1.104 2.485-1.104H6.2M4.9 10.1a2.6 2.6 0 1 1 0-5.2 2.6 2.6 0 0 1 0 5.2Z"
    />
  </svg>
)
